import React from 'react'
import PropTypes from 'prop-types'
import { LoginCardContainer } from '../Auth.styles'

const LoginCard = ({ children, style = {} }) => (
  <LoginCardContainer style={style}>{children}</LoginCardContainer>
)

LoginCard.propTypes = {
  children: PropTypes.node.isRequired
}

export default LoginCard
